import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import {
  FilterFormActions,
  FilterFormClearButton,
  FilterFormSubmitButton,
} from 'components/filters/FilterFormButtons';
import useFilterFormContextApplyFiltersStoredValues from 'components/filters/useFilterFormContextApplyFiltersStoredValues';
import useFilterFormContextFormHandlers from 'components/filters/useFilterFormContextFormHandlers';
import DateTimePickerField from 'components/forms/dateTimePickerField/DateTimePickerField';
import PropertyMultiSelectField from 'components/forms/domain/property/PropertyMultiSelectField/PropertyMultiSelectField';
import { Form } from 'components/forms/form/Form';
import CommonFiltersContainer from 'pages/automations/common/CommonFiltersContainer';
import ActionTypeMultiSelectField from 'pages/automations/triggers/filters/fields/ActionTypeMultiSelectField';
import { AVAILABLE_FILTER_ACTIONS } from './ScheduledMessagesTabFilters.constants';
import { ScheduledMessagesTabFiltersSchemaType } from './ScheduledMessagesTabFilters.schema';
import ScheduledMessageSearchField from './fields/ScheduledMessageSearchField';
import StatusMultiSelectField from './fields/StatusMultiSelectField';
import useSearchedScheduledMessage from './useSearchedScheduledMessage';

const ScheduledMessagesTabFilters = () => {
  const { t } = useTranslation();
  const { handleClear, handleSubmit } =
    useFilterFormContextFormHandlers<ScheduledMessagesTabFiltersSchemaType>();
  const isSearchActive = !!useSearchedScheduledMessage();

  useFilterFormContextApplyFiltersStoredValues();

  return (
    <CommonFiltersContainer
      searchField={<ScheduledMessageSearchField />}
      stateStorageKey="scheduled-messages-tab-filters-expanded"
    >
      <Form
        data-testid="scheduled-messages-tab-filters-form"
        horizontal
        onSubmit={handleSubmit}
      >
        <Row>
          <Col md={4} sm={6}>
            <DateTimePickerField
              colSmInput={8}
              colSmLabel={4}
              disabled={isSearchActive}
              label={t('pageAutomations.scheduledMessages.filters.from')}
              name="from"
            />
          </Col>
          <Col md={4} sm={6}>
            <ActionTypeMultiSelectField
              availableActions={AVAILABLE_FILTER_ACTIONS}
              disabled={isSearchActive}
              label={t('pageAutomations.scheduledMessages.filters.sentVia')}
              name="sentVia"
            />
          </Col>
          <Col md={4} sm={6}>
            <StatusMultiSelectField
              disabled={isSearchActive}
              label={t('pageAutomations.scheduledMessages.filters.status')}
              name="status"
            />
          </Col>
        </Row>
        <Row>
          <Col md={4} sm={6}>
            <DateTimePickerField
              colSmInput={8}
              colSmLabel={4}
              disabled={isSearchActive}
              label={t('pageAutomations.scheduledMessages.filters.to')}
              name="to"
            />
          </Col>
          <Col md={4} sm={6}>
            <PropertyMultiSelectField
              colSmInput={8}
              colSmLabel={4}
              disabled={isSearchActive}
              enableHotels={false}
              enableUnitTypes
              isSelectAllEnabled
              label={t('pageAutomations.scheduledMessages.filters.propertyUid')}
              name="propertyUid"
              placeholder={t('common.selectOption')}
            />
          </Col>
        </Row>

        <FilterFormActions>
          <FilterFormClearButton onClick={handleClear} />
          <FilterFormSubmitButton disabled={isSearchActive} />
        </FilterFormActions>
      </Form>
    </CommonFiltersContainer>
  );
};

export default ScheduledMessagesTabFilters;
